import BaseModel from '../../../../../base';
import glossary from './glossary';

export default class TournamentStageGroupMemberHistory extends BaseModel {
  constructor(history = {}, url) {
    super(history, url);

    this.user_id = history.user_id;
    this.tournament_stage_group_id = history.tournament_stage_group_id;
    this.parent_tournament_stage_group_id = history.parent_tournament_stage_group_id;

    this.tournament_stage = history.tournament_stage
      ? { ...history.tournament_stage }
      : undefined;
    this.tournament_stage_group = history.tournament_stage_group
      ? { ...history.tournament_stage_group }
      : undefined;
    this.parent_tournament_stage_group = history.parent_tournament_stage_group
      ? { ...history.parent_tournament_stage_group }
      : undefined;
    this.tournament = history.tournament
      ? { ...history.tournament }
      : undefined;

    this.score = history.score;
    this.final_result = history.final_result;
    this.description = history.description;
    this.status = history.status;
    this.created_at = history.created_at;

    this.event_level = history.event_level;
  }

  static get glossary() {
    return glossary;
  }
}
